import { combineReducers } from 'redux';
import toastReducer from './toast';
import appSettingsReducer from './appSettings';
import loaderReducer from './loader';


const rootReducer = combineReducers({
	// toast,
	appSettingsReducer,
	loaderReducer,
	toastReducer
});

export default rootReducer;